import { Sparkles, ShieldCheck, Rocket, Wallet } from "lucide-react";
import { useReveal } from "../lib/useReveal";

const points = [
  {
    icon: Sparkles,
    title: "Stay creative",
    text: "You focus on the work. We handle the inboxes, contracts, and timelines.",
  },
  {
    icon: Wallet,
    title: "Maximize your rate",
    text: "Negotiation, exclusivity windows, and usage rights are not afterthoughts.",
  },
  {
    icon: ShieldCheck,
    title: "Long-term protection",
    text: "We build a brand around you — not one viral moment.",
  },
  {
    icon: Rocket,
    title: "Audience strategy",
    text: "Format, cadence, and platform-specific playbooks that compound.",
  },
];

export const ForCreators = () => {
  const headRef = useReveal();
  return (
    <section
      id="creators"
      data-testid="for-creators-section"
      className="relative bg-[#050505] py-24 md:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div ref={headRef} className="reveal grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-16">
          <div className="lg:col-span-7">
            <span className="text-xs uppercase tracking-[0.28em] text-neutral-500 font-medium">
              05 / For Creators
            </span>
            <h2
              data-testid="for-creators-heading"
              className="mt-6 font-display text-4xl sm:text-5xl md:text-6xl font-light tracking-tighter leading-[1.02]"
            >
              Make the work.
              <br />
              <span className="italic font-medium">We&apos;ll make the deals.</span>
            </h2>
          </div>
          <p className="lg:col-span-5 text-base md:text-lg text-neutral-400 leading-relaxed">
            Focus on content while we handle business opportunities, negotiations,
            outreach, and partnerships. Built for creators who actually live online.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {points.map((p, i) => (
            <PointCard key={p.title} {...p} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

const PointCard = ({ icon: Icon, title, text, index }) => {
  const ref = useReveal();
  return (
    <div
      ref={ref}
      data-testid={`for-creators-point-${index}`}
      style={{ transitionDelay: `${index * 80}ms` }}
      className="reveal group rounded-[20px] border border-white/10 bg-[#0c0c0c] hover:border-white/30 hover:-translate-y-1.5 transition-all duration-500 p-7 min-h-[220px] flex flex-col justify-between border-shine"
    >
      <div className="h-11 w-11 rounded-full border border-white/15 bg-white/5 flex items-center justify-center">
        <Icon className="h-5 w-5 text-white" strokeWidth={1.5} />
      </div>
      <div className="mt-8">
        <h3 className="font-display text-xl md:text-2xl font-medium tracking-tight">
          {title}
        </h3>
        <p className="mt-2 text-sm text-neutral-400 leading-relaxed">{text}</p>
      </div>
    </div>
  );
};

export default ForCreators;
